<template>
	<div>
		<div class="form-row" v-if="!pedido">
			<div class="form-group col-md-12">
		        <label>Pedido *</label>
		        <select-two
		        	:options="pedidos"
		        	:formId="name+'pedido_id'"
		        	:valueDefault="dados.pedido_id"
		        	@selected="setPedidoId"
		        	@searching="getDados"
		        	@noValue="setPedidoId('')"
		        	arrayValue="id">
		        </select-two>
		        <div class="invalid-feedback" :id="name+'pedido_id-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Data do pagamento</label>
		        <input
		        	type="date"
		        	class="form-control"
		        	v-model="dados.data"
		        	:id="name+'data'"
		        	@input="clearValidation('data')">
		        <div class="invalid-feedback" :id="name+'data-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Forma de Pagamento *</label>
		        <select
					class="form-control"
				    v-model="dados.forma_pagamento"
				    :id="name+'forma_pagamento'">
					<option>Espécie</option>
					<option>Débito</option>
					<option>Crédito</option>
					<option>Transferência</option>
					<option>Boleto</option>
                    <option>Pix</option>
				</select>
		        <div class="invalid-feedback" :id="name+'forma_pagamento-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Valor *</label>
                <money
                    :id="name+'valor'"
                    class="form-control"
                    v-model="dados.valor"
                    @input="clearValidation('valor')">
                </money>
		        <div class="invalid-feedback" :id="name+'valor-invalid-feedback'"></div>
		    </div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dados', 'name', 'errors', 'pedido'],
		data(){
			return {
				elementos: Object.keys(this.dados),
				pedidos: [],
			}
		},
		created(){
			if(!this.pedido){
				this.getDados();
			} else {
				this.getValorPagar(this.pedido)
			}
		},
		methods : {
			getDados(pesquisa=''){
				axios.get(this.$url+'/api/adm/pedidos/nao-pagos?pesquisa='+pesquisa)
	            .then(response => {
	                this.pedidos = response.data.data
	            })
			},
			getValorPagar(id){
				axios.get(this.$url+'/api/adm/receita/valor-pagar/'+id)
	            .then(response => {
	                this.dados.valor = response.data
	            })
			},
			setPedidoId(valor){
				this.dados.pedido_id = valor.id;
				this.getValorPagar(valor.id);
			},
			clearValidation(element){
				this.$bshValidation.clear(element, this.name);
			}
        },
        watch: {
            errors: function() {
                this.$bshValidation.valide(this.elementos, this.errors, this.name);
            },
        }
    }
</script>
